import { render } from "./Dokumen.vue?vue&type=template&id=7e169e78"
import script from "./Dokumen.vue?vue&type=script&lang=js"
export * from "./Dokumen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__